import { Module } from 'vuex';
import axios from 'axios';

export const dialogueStateStore: Module<any, any> = {
  state: {
    dialogueState: ''
  },
  getters: {
    dialogueState: state => state.dialogueState
  },
  mutations: {
    updateDialogueState(state, dialogueState) {
      state.dialogueState = dialogueState;
    }
  },
  actions: {
    async getDialogueState({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        axios.get('api/dm/dialogues/' + params.dialogueId + '/state').then(
          response => {
            commit('updateDialogueState', response.data);
            resolve(response.data);
          },
          error => {
            console.log(error);
            reject();
          }
        );
      });
    }
  }
};
